/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { CategoryAdmin } from './CategoryAdmin'
import {
  CategoryAdminFromJSON,
  CategoryAdminFromJSONTyped,
  CategoryAdminToJSON,
} from './CategoryAdmin'

/**
 *
 * @export
 * @interface PaginatedCategoryAdmin
 */
export interface PaginatedCategoryAdmin {
  /**
   *
   * @type {Array<CategoryAdmin>}
   * @memberof PaginatedCategoryAdmin
   */
  results: Array<CategoryAdmin>
  /**
   *
   * @type {number}
   * @memberof PaginatedCategoryAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedCategoryAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedCategoryAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedCategoryAdmin interface.
 */
export function instanceOfPaginatedCategoryAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedCategoryAdminFromJSON(json: any): PaginatedCategoryAdmin {
  return PaginatedCategoryAdminFromJSONTyped(json, false)
}

export function PaginatedCategoryAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedCategoryAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(CategoryAdminFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedCategoryAdminToJSON(value?: PaginatedCategoryAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(CategoryAdminToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
